export var DynamicPaymentMethodsTheme;
(function (DynamicPaymentMethodsTheme) {
    DynamicPaymentMethodsTheme[DynamicPaymentMethodsTheme["light"] = 0] = "light";
    DynamicPaymentMethodsTheme[DynamicPaymentMethodsTheme["dark"] = 1] = "dark";
})(DynamicPaymentMethodsTheme || (DynamicPaymentMethodsTheme = {}));
export var DynamicPaymentMethodsShape;
(function (DynamicPaymentMethodsShape) {
    DynamicPaymentMethodsShape[DynamicPaymentMethodsShape["rect"] = 0] = "rect";
    DynamicPaymentMethodsShape[DynamicPaymentMethodsShape["pill"] = 1] = "pill";
})(DynamicPaymentMethodsShape || (DynamicPaymentMethodsShape = {}));
//# sourceMappingURL=productPageSettings.enums.js.map